module.exports = __webpack_public_path__ + "img/DSC_2901-xs.4651112e.png";